module.exports = __webpack_public_path__ + "fonts/DaxWebPro.5b5d67e8.woff";